import { styled } from '@mui/material/styles';
import { Box, Button, BoxProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material';

export const StyledSettingsContainer = styled(Box)({});

export const StyledFormContainer = styled(Box)<BoxProps>({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '16px',
  marginBottom: '32px',
  width: '100%',
});

interface StyledSaveButtonProps {
  isActive: boolean;
}

export const StyledSaveButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<StyledSaveButtonProps>(({ isActive }) => ({
  width: '100px',
  fontFamily: 'Outfit',
  fontSize: '16px',
  fontWeight: '500',
  backgroundColor: isActive ? 'var(--primary-blue)' : 'var(--inactive-btn)',
  color: isActive ? 'var(--white)' : 'var(--instructions)',
  '&:hover': {
    backgroundColor: isActive
      ? 'var(--primary-blue-dark)'
      : 'var(--inactive-btn)',
  },
  '&:disabled': {
    backgroundColor: 'var(--inactive-btn)',
    color: 'var(--instructions)',
    cursor: 'not-allowed',
  },
}));

export const imagePreviewBoxStyles: SxProps<Theme> = {
  width: 100,
  height: 100,
  borderRadius: '50%',
  border: '2px solid var(--border)',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'var(--text-bg)',
  boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
  marginBottom: '8px',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};

export const StyledPasswordFieldContainer = styled(Box)({
  width: '400px',
  marginBottom: '24px',
});

export const StyledMobileFieldContainer = styled(Box)({
  width: '400px',
  marginBottom: '24px',
});
